import React from "react"
import styled from "styled-components"
import cookie from "react-cookie"
import qs from "query-string"
import {pushRoute} from "../../common/route"
import tracker from "../../common/tracker"
import { colors, constants } from "buoy-theme"

const LinkOnNewTab = ({link, text, newTab}) => (
  <a href={link} target={newTab ? "_blank": ""}>{text}</a>
)

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`

const MessageBox = styled.div`
  max-width: 448px;
	border-radius: 6px;
	background-color: ${colors.white};
	box-shadow: ${constants.boxShadow};
	padding: 26px 36px 54px;
	flex: 1;
`

const Header = styled.h1`
	font-family: bree-serif;
	font-weight: 300;
	font-size: 36px;
	line-height: 1.33;
	color: ${colors.primary};
	margin: 0;
	margin-bottom: 12px;
`

const Text = styled.p`
  font-family: SlatePro-Light;
	font-size: 18px;
	font-weight: 300;
	line-height: 1.33;
	color: ${colors.neutralDarkest};
	margin: 0;
`

const Activation = ({countDown, header, redirect, msg}) => (
  <Container>
    <MessageBox>
      {header && <Header>{header}</Header>}
      <Text>{msg}
        {redirect && <p>
          Redirecting you to start a Buoy visit in {countDown} seconds,
          or <LinkOnNewTab link={"/symptom-checker/"} text={"go there now"} newTab={false} />
        </p>}
      </Text>
    </MessageBox>
  </Container>
)


class ActivationPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {countDown: 10, msg: ''}
  }

  componentDidMount() {
    let query = qs.parse(this.props.location.search)
    let request = query.m === 'requested'
    // The messaging logic is redundant with the get_confirmation view logic
    tracker.activation()
    let email = cookie.load('email')
    if(query.resetpass === '1'){
      // tailored msging for password change
      if(query.m === 'success'){
        this.setState({msg: "Your password was successfully reset!"})
      }
      else if(request){
        this.setState({header: "Password reset link sent", msg: `A password reset link was sent to ${email}. Please check your inbox to continue.`})
      }
      else if(query.m === 'invalid'){
        this.setState({msg: "That link is no longer valid. We're sending you a new one."})
      }
      else{
        this.setState({msg: "Password reset failed. Please try again later or contact support@buoyhealth.com"})
      }
    }
    else{
      // tailored msging for account registration
      if(query.m === 'success'){
        this.setState({msg: "Your account is now activated! In the future, login with your email and password."})
      }
      else if(request){
        this.setState({header: "Please verify your email address", msg: `You're almost done! A verification message has been sent to ${email}.  Check your email and follow the link to finish setting up your Buoy account.`})
      }
      else if(query.m === 'invalid'){
        this.setState({msg: "That link is no longer valid. We're sending you a new one."})
      }
      else{
        this.setState({msg: "Account registration failed. Plase try again later or contact support@buoyhealth.com"})
      }
    }

    if (!request) {
      let initialCountDown = this.state.countDown
      setInterval(() => {
        if (this.state.countDown > 0) {
          this.setState({countDown: this.state.countDown - 1})
        }
      }, 1000)

      setTimeout(function(){
        pushRoute('/', true)
      }, (initialCountDown+0.5)*1000)
    }
  }

  componentWillUnmount(){
    this.setState({countDown: 10})
  }

  render(){

    let query = qs.parse(this.props.location.search)

    return (
      <Activation 
        {...this.state}
        redirect={query.m !== 'requested'}
      />
    )
  }
}

export { ActivationPage as default }



// WEBPACK FOOTER //
// ./assets/auth/components/AccountActivation.js